import api from "./api";

/** Larger dirham icon in product tables only (rest of app uses default scale). */
export const PRODUCT_CURRENCY_SYMBOL_SCALE = 1.08;

/** Variants from list API (`variants`) or legacy (`ProductVariants`). */
export function getProductVariants(p) {
  return p?.variants ?? p?.ProductVariants ?? [];
}

/** Category label from nested `category` or legacy `ProductCategory`. */
export function getProductCategoryName(p) {
  return (
    p?.category?.name_en ||
    p?.category?.name_ar ||
    p?.ProductCategory?.name_en ||
    p?.ProductCategory?.name_ar ||
    "—"
  );
}

export function getProductDisplayPrice(p) {
  return Number(p?.price ?? p?.starting_price ?? 0);
}

/** Fetch product tag options from backend GET /product/tag/list (or GET /product/manage/data) */
export async function fetchProductTagOptions() {
  try {
    const res = await api.get("/product/tag/list");
    const raw = res.data?.data;
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw?.tag_list)) return raw.tag_list;
    if (Array.isArray(raw?.tags)) return raw.tags;
  } catch (err) {
    try {
      const res = await api.get("/product/manage/data");
      const raw = res.data?.data;
      if (Array.isArray(raw?.tag_list)) return raw.tag_list;
      if (Array.isArray(raw)) return raw;
    } catch (e) {
      console.error("fetchProductTagOptions error:", e);
    }
  }
  return [];
}

